import { ReactNode } from 'react';

interface TimelineEventDescriptionProps {
  /** Display name of the user who performed the action */
  userName: string;
  /** Action description (e.g. "posted a message", "uploaded photo.jpg") */
  children: ReactNode;
}

/**
 * Consistent description rendering for timeline entries.
 * Renders the user name in bold followed by the action text.
 */
export function TimelineEventDescription({
  userName,
  children,
}: TimelineEventDescriptionProps) {
  return (
    <span>
      <span className="text-foreground font-medium">{userName}</span> {children}
    </span>
  );
}
